import styled from '@emotion/styled'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import ListSubheader from '@mui/material/ListSubheader'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import theme from 'theme'
import { inputFieldStates } from '../inputStates.styles'

export const StyledInputLabel = styled(InputLabel)`
  color: ${theme.colors.devicesSecondaryText};
  transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms, max-width 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;

  &.Mui-focused {
    color: ${theme.colors.dropdownLabel};
    background-color: ${theme.colors.labelCardBg};
  }

  /* Reset to original position when not focused and not filled */
  &:not(.Mui-focused):not(.MuiFormLabel-filled) {
    transform: translate(${theme.spacing.xMd}px, ${theme.spacing.small}px) scale(1);
  }

  &[data-shrink='true'] {
    color: ${theme.colors.dropdownLabel};
    background-color: ${theme.colors.labelCardBg};
  }
`

export const StyledSelect = styled(Select)`
  color: ${theme.colors.devicesSecondaryText};
  ${inputFieldStates()}

  svg {
    color: ${theme.colors.devicesSecondaryText};
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }

  &.Mui-focused {
    color: ${theme.colors.cta};
  }
`

export const StyledListSubheader = styled(ListSubheader)`
  position: sticky;
  top: 0;
  z-index: 10;
  padding: ${theme.spacing.xSmall}px ${theme.spacing.xSmall}px 0 ${theme.spacing.xSmall}px;
  background-color: ${theme.colors.menuBg};

  &.group-header {
    position: static;
    padding: ${theme.spacing.xSmall}px ${theme.spacing.small}px;
    color: ${theme.colors.devicesSecondaryText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.medium};
    line-height: 20px;
  }
`

export const StyledTextField = styled(TextField)`
  background: ${theme.colors.surfaceContainerBackground};
  border-radius: ${theme.attributes.borderRadius.mediumSmall};

  input,
  svg {
    color: ${theme.colors.devicesSecondaryText};
  }

  fieldset {
    border: none;
  }
`

export const StyledMenuItem = styled(MenuItem)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${theme.spacing.sm}px ${theme.spacing.small}px;
  cursor: pointer;
  font-size: 14px;
  color: ${theme.colors.menuItemText};

  &:hover,
  &.Mui-selected:hover,
  &.hovered {
    background-color: ${theme.colors.surfaceContainerBackground};
    color: ${theme.colors.cta};

    svg {
      color: ${theme.colors.cta};
    }
  }

  &.Mui-selected {
    background-color: ${theme.colors.surfaceContainerBackground};
    color: ${theme.colors.cta};
  }

  html[data-theme='light'] & {
    &:hover,
    &.Mui-selected:hover,
    &.hovered,
    &.Mui-selected {
      background-color: ${theme.colors.menuItemHover};
    }
  }

  &.not-found {
    pointer-events: none;
  }

  .search-match {
    color: ${theme.colors.cta};
    font-weight: ${theme.typography.fontWeight.bold};
  }

  &:hover .search-match,
  &.Mui-selected .search-match,
  &.hovered .search-match {
    color: inherit;
  }

  svg {
    font-size: ${theme.iconSize.small}px;
  }
`
